module.exports = __webpack_public_path__ + "img/mercado-municipal.3f573ec2.jpg";